import type { TOC } from '@ember/component/template-only';

interface Signature {
  Args: {};
  Blocks: { default: [] };
}

const ItemsTemplate: TOC<Signature> = <template>{{outlet}}</template>;

export default ItemsTemplate;
